import { COMPOSED_OF } from '~/scripts/constants/common-kids';

export default class ModalWfRoleController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} role
	 * @param {boolean} edit
	 * @param {boolean} create
	 */
	constructor(
		$uibModalInstance,
		role,
		edit,
		create,
	) {
		this.$uibModalInstance = $uibModalInstance;
		this.role = role;
		this.edit = edit;

		/** @type {?import('angular').IFormController} */
		this.formRole = null;

		this.creation = create;

		/** @type {any} */
		this.tmp = {
			validate: true,
		};

		/** @type {any[]} */
		this.profils = [];
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	create() {
		this.role.setName(this.role.getName());
		for (const profil of this.profils) {
			this.role.addRelation(COMPOSED_OF, {
				kid: profil.kid,
				isa: {
					objid: 'K_NODE;KPROFIL',
				},
			});
		}
		this.$uibModalInstance.close({ type: 'ADD', role: this.role });
	}
}
